export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://static.readdy.ai/image/aea82ce1bdb1715498721ef3bf0e643f/3ed1cf1b0ebf95243d711d53c812d3a3.png" 
                alt="Garden State Junk Removal Logo" 
                className="h-12 w-auto"
              />
              <span className="text-xl font-bold">Garden State Junk Removal</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Professional junk removal services across New Jersey since 1998. We specialize in eco-friendly disposal, recycling, and donation of unwanted items. Trusted by thousands of residential and commercial clients.
            </p>
            <div className="flex items-center space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#home" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Home
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Services
                </a>
              </li>
              <li>
                <a href="#how-it-works" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  How It Works
                </a>
              </li>
              <li>
                <a href="#booking" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Free Estimate
                </a>
              </li>
              <li>
                <a href="#testimonials" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Testimonials
                </a>
              </li>
              <li>
                <a href="#faq" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#service-areas" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Service Areas
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400">Phone</div>
                  <a href="tel:+19089021076" className="text-white hover:text-teal-400 transition-colors">
                    (908) 902-1076
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400">Email</div>
                  <a href="mailto:Joe@Gardenstatejunkremovals.com" className="text-white hover:text-teal-400 transition-colors break-all">
                    Joe@Gardenstatejunkremovals.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-global-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400">Website</div>
                  <a href="https://gardenstatejunkremovals.com" target="_blank" rel="noopener noreferrer" className="text-white hover:text-teal-400 transition-colors break-all">
                    Gardenstatejunkremovals.com
                  </a>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400">Hours of Operation</div>
                  <div className="text-white text-sm space-y-1">
                    <div>Monday - Friday: 7:00am - 7:00pm</div>
                    <div>Saturday: 7:00am - 5:00pm</div>
                    <div>Sunday: Closed</div>
                  </div>
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 text-lg mt-0.5"></i>
                <div>
                  <div className="text-sm text-gray-400">Service Areas</div>
                  <div className="text-white text-sm">
                    All of New Jersey<br />The Garden State
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © {currentYear} Garden State Junk Removal. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-teal-400 transition-colors">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}